class ResultsCircles {
  constructor(container) {
    this.container = container;
    this.tabs = [];
    this.swiper = null;
    this.init();
  }

  init() {
    this.setupTabs();
    this.initSwiper();
  }

  setupTabs() {
    const tabElements = this.container.querySelectorAll('.tab');
    tabElements.forEach((tab, index) => {
      const tabName = tab.closest('[data-tabs-container]')
        .parentElement.querySelector(`[data-tab-id="${tab.dataset.tabId}"]`)
        ?.dataset.tabName || `Tab ${index + 1}`;
      this.tabs.push(tabName);
    });
  }

  initSwiper() {
    const swiperElement = this.container.querySelector('.tabs');
    if (!swiperElement) return;

    this.swiper = new Swiper(swiperElement, {
      fadeEffect: { crossFade: true },
      virtualTranslate: true,
      autoplay: false,
      speed: 1000,
      slidesPerView: 1,
      effect: 'fade',
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: (index, className) => {
          return `<span class="${className}">Contorno de ojos (tras 56 días de uso)</span>`;
        }
      },
      on: {
        slideChangeTransitionEnd: () => this.animateActiveSlide(),
        init: () => this.animateActiveSlide()
      }
    });
  }

  animateActiveSlide() {
    const activeIndex = this.swiper ? this.swiper.activeIndex : 0;
    const activeSlide = this.container.querySelector(`.tab:nth-child(${activeIndex + 1})`);
    if (!activeSlide) return;

    const counters = activeSlide.querySelectorAll('.num');
    counters.forEach(counter => this.animateCounter(counter));
  }

  animateCounter(counter) {
    const textElement = counter.querySelector('text.title');
    const circleElement = counter.querySelector('circle.progress');
    
    if (!textElement || !circleElement) return;

    const targetPercent = parseInt(textElement.dataset.target) || 0;
    const duration = 1500;
    const startTime = performance.now();

    // Animate number
    const animateNumber = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      
      // Easing function (ease-out)
      const easeOut = 1 - Math.pow(1 - progress, 3);
      const currentValue = Math.floor(easeOut * targetPercent);
      
      textElement.textContent = `${currentValue}%`;

      if (progress < 1) {
        requestAnimationFrame(animateNumber);
      } else {
        textElement.textContent = `${targetPercent}%`;
      }
    };

    // Animate circle
    const dashArray = (targetPercent / 100) * 1000;
    const dashOffset = 1000 - dashArray;
    circleElement.style.strokeDasharray = `${dashArray} ${dashOffset}`;

    requestAnimationFrame(animateNumber);
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.results-circles-section');
  containers.forEach(container => new ResultsCircles(container));
});

// Reinitialize on Shopify section load (theme editor)
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const container = event.target.querySelector('.results-circles-section');
    if (container) new ResultsCircles(container);
  });
}